import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ({ items = [], title = "Häufig gestellte Fragen" }) {
  if (!items.length) return null;

  return (
    <section className="py-16 md:py-24 bg-[#1a1a1a]" data-testid="faq-section">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="max-w-3xl mx-auto">
          <div className="h-0.5 w-12 bg-[#E61D38] mb-6" />
          <h2
            className="text-3xl md:text-4xl font-black text-white uppercase tracking-tight mb-12"
            style={{ fontFamily: "Montserrat, sans-serif" }}
          >
            {title}
          </h2>

          <Accordion type="single" collapsible className="space-y-2">
            {items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-[#262626] border border-white/5 px-6 data-[state=open]:border-[#E61D38]/40"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-white font-semibold text-left text-sm hover:text-[#E61D38] hover:no-underline py-5 [&[data-state=open]]:text-[#E61D38]">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 text-sm leading-relaxed pb-5">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
